import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Loader2, VideoOff } from 'lucide-react';
import { Button } from '@easyflow/ui-frontend/components/ui/button';

export default function VideoGuestRedirect() {
  const { token } = useParams<{ token: string }>();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!token) {
      setError('Link non valido');
      return;
    }

    const resolveGuest = async () => {
      try {
        const baseUrl = window.location.origin;
        const res = await fetch(`${baseUrl}/api/video/guest/${token}/resolve`);
        const data = await res.json();

        if (!data.success) {
          setError(data.error || 'Link non valido o scaduto');
          return;
        }

        const { tenantSlug, roomId } = data.data;
        navigate(`/${tenantSlug}/video/${roomId}?guest=${token}`, { replace: true });
      } catch (e) {
        const msg = e instanceof Error ? e.message : String(e);
        setError(msg || 'Errore di connessione');
      }
    };

    resolveGuest();
  }, [token, navigate]);

  if (error) {
    return (
      <div className="flex items-center justify-center h-screen bg-gray-950 text-white">
        <div className="text-center space-y-4">
          <VideoOff className="w-16 h-16 text-red-400 mx-auto" />
          <h2 className="text-xl font-semibold">Impossibile accedere alla video call</h2>
          <p className="text-gray-400">{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center h-screen bg-gray-950 text-white">
      <div className="text-center space-y-4">
        <Loader2 className="w-8 h-8 animate-spin text-indigo-400 mx-auto" />
        <p className="text-gray-400">Accesso alla video call in corso...</p>
      </div>
    </div>
  );
}
